/* DRGSKL Forge — Theme interactions */
(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Cart ---------- */
  const cartDrawer = () => $('#CartDrawer');
  const cartOverlay = () => $('#CartDrawerOverlay');

  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.themeMoneyFormat || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function changeCart(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    return res.json();
  }

  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    return res.json();
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
      el.setAttribute('data-count', String(count));
    });
  }

  function updateFreeShipping(cart, root) {
    const bar = $('[data-free-shipping]', root || document);
    if (!bar) return;
    const threshold = parseInt(bar.dataset.threshold || '9900', 10) || 9900;
    const total = cart.total_price || 0;
    const remaining = Math.max(threshold - total, 0);
    const pct = threshold > 0 ? Math.min((total / threshold) * 100, 100) : 0;
    const fill = $('[data-free-shipping-fill]', bar);
    const msg = $('[data-free-shipping-msg]', bar);
    const complete = remaining <= 0 && total > 0;

    bar.classList.toggle('is-complete', complete || (remaining <= 0 && total >= threshold));
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      if (total <= 0) {
        msg.textContent = 'Free shipping on orders over ' + formatMoney(threshold);
      } else if (remaining > 0) {
        msg.textContent = 'Add ' + formatMoney(remaining) + ' more for free shipping';
      } else {
        msg.textContent = 'You unlocked free shipping';
        bar.classList.add('is-complete');
      }
    }
  }

  function renderCart(cart) {
    const drawer = cartDrawer();
    if (!drawer) return;

    updateCartCount(cart.item_count);

    const body = $('[data-cart-body]', drawer);
    const empty = $('[data-cart-empty]', drawer);
    const footer = $('[data-cart-footer]', drawer);
    const subtotal = $('[data-cart-subtotal]', drawer);
    const countLabel = $('[data-cart-drawer-count]', drawer);

    if (countLabel) {
      countLabel.textContent =
        cart.item_count > 0
          ? cart.item_count + (cart.item_count === 1 ? ' item' : ' items')
          : 'Empty';
    }

    updateFreeShipping(cart, drawer);

    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '';
      body.hidden = true;
      if (empty) empty.hidden = false;
      if (footer) footer.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;
    body.hidden = false;

    body.innerHTML = cart.items
      .map((item, index) => {
        let img = '';
        if (item.image) {
          const src = item.image.includes('?')
            ? item.image
            : item.image.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_200x$1$2');
          img = `<img src="${src}" alt="${escapeHtml(item.product_title)}" width="84" height="84" loading="lazy">`;
        }
        const variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-line__variant">${escapeHtml(item.variant_title)}</p>`
            : '';
        return `
        <article class="cart-line" data-line="${index + 1}">
          <a class="cart-line__media" href="${item.url}">${img}</a>
          <div class="cart-line__info">
            <a class="cart-line__title" href="${item.url}">${escapeHtml(item.product_title)}</a>
            ${variant}
            <div class="cart-line__row">
              <div class="qty cart-line__qty" data-qty-line="${index + 1}">
                <button type="button" class="qty__btn" data-qty-change="-1" aria-label="Decrease">−</button>
                <input class="qty__input" type="number" min="0" value="${item.quantity}" data-qty-input aria-label="Quantity">
                <button type="button" class="qty__btn" data-qty-change="1" aria-label="Increase">+</button>
              </div>
              <span class="cart-line__price">${formatMoney(item.final_line_price)}</span>
            </div>
            <button type="button" class="cart-line__remove" data-remove-line="${index + 1}">Remove</button>
          </div>
        </article>`;
      })
      .join('');

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function openCart() {
    const drawer = cartDrawer();
    const overlay = cartOverlay();
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    drawer.setAttribute('aria-hidden', 'false');
    const closeBtn = $('[data-cart-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }

  function closeCart() {
    const drawer = cartDrawer();
    const overlay = cartOverlay();
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  async function refreshCartUI() {
    try {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (e) {
      console.error(e);
    }
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) {
      e.preventDefault();
      await refreshCartUI();
      openCart();
      return;
    }

    if (e.target.closest('[data-cart-close]') || e.target.id === 'CartDrawerOverlay') {
      closeCart();
      return;
    }

    const removeBtn = e.target.closest('[data-remove-line]');
    if (removeBtn) {
      const line = parseInt(removeBtn.dataset.removeLine, 10);
      const cart = await changeCart(line, 0);
      renderCart(cart);
      return;
    }

    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('[data-qty-line]');
      const input = $('[data-qty-input]', wrap);
      const line = parseInt(wrap.dataset.qtyLine, 10);
      const delta = parseInt(qtyBtn.dataset.qtyChange, 10);
      const next = Math.max(0, parseInt(input.value || '0', 10) + delta);
      input.value = next;
      const cart = await changeCart(line, next);
      renderCart(cart);
      return;
    }

    const menuToggle = e.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const nav = $('#MobileNav');
      if (!nav) return;
      const open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      $$('[data-menu-toggle]').forEach((btn) => {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.body.classList.toggle('overflow-hidden', open);
      document.body.classList.toggle('mobile-nav-open', open);
      /* Keep header visible while drawer is open */
      if (header) header.classList.remove('is-hidden');
      return;
    }

    const bladeCard = e.target.closest('[data-blade-option]');
    if (bladeCard) {
      e.preventDefault();
      const root = bladeCard.closest('[data-blade-guide]') || document;
      const target = bladeCard.getAttribute('data-blade-target');
      if (!target) return;

      $$('[data-blade-option]', root).forEach((el) => {
        const on = el === bladeCard;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      $$('[data-blade-panel]', root).forEach((panel) => {
        const on = panel.getAttribute('data-blade-panel') === target;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });

      const cue = $('[data-blade-cue]', root);
      if (cue) cue.textContent = 'Step 2 — See your match';
    }
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const wrap = input.closest('[data-qty-line]');
    if (!wrap) return;
    const line = parseInt(wrap.dataset.qtyLine, 10);
    const qty = Math.max(0, parseInt(input.value || '0', 10));
    const cart = await changeCart(line, qty);
    renderCart(cart);
  });

  /* Product qty on PDP */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-product-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('[data-product-qty]');
    const input = wrap && wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    const delta = parseInt(btn.getAttribute('data-product-qty-change'), 10);
    const next = Math.max(1, parseInt(input.value || '1', 10) + delta);
    input.value = next;
  });

  /* Product form ATC */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    try {
      const fd = new FormData(form);
      const id = fd.get('id');
      const quantity = parseInt(fd.get('quantity') || '1', 10);
      await addToCart([{ id: Number(id), quantity }]);
      await refreshCartUI();
      if (document.body.dataset.cartType !== 'page') openCart();
      else window.location.href = '/cart';
    } catch (err) {
      alert(err.message || 'Error adding to cart');
    } finally {
      if (btn) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    }
  });

  /* Variant picker */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !e.target.matches('[data-option-select], [data-option-radio]')) return;

    const jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const options = $$('[data-option-select], [data-option-radio]:checked', form).map((el) => el.value);
    const variant = product.variants.find((v) => v.options.every((opt, i) => opt === options[i]));
    if (!variant) return;

    const idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = variant.id;

    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl) {
      if (variant.compare_at_price > variant.price) {
        priceEl.innerHTML = `<span class="price__sale">${formatMoney(variant.price)}</span><s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`;
      } else {
        priceEl.innerHTML = `<span>${formatMoney(variant.price)}</span>`;
      }
    }

    const atcButtons = Array.from(form.querySelectorAll('[type="submit"]'));
    const stickyAtc = document.querySelector('[data-sticky-atc] .btn');
    const primaryAtc = atcButtons[0];
    const label = variant.available
      ? (primaryAtc && primaryAtc.dataset.addLabel) || 'Add to cart'
      : (primaryAtc && primaryAtc.dataset.soldLabel) || 'Sold out';
    atcButtons.concat(stickyAtc ? [stickyAtc] : []).forEach((atc) => {
      if (!atc) return;
      atc.disabled = !variant.available;
      const span = atc.querySelector('span');
      if (span) span.textContent = label;
      else atc.textContent = label;
    });

    if (variant.featured_image) {
      const gallery = document.querySelector('[data-product-gallery]');
      const src = variant.featured_image.src.replace(/(\.[^.]*)$/, '_1400x$1');
      if (gallery && window.DrgsklGallery) {
        window.DrgsklGallery.setMain(gallery, {
          src,
          srcset: src,
          alt: variant.featured_image.alt || product.title,
          zoomSrc: variant.featured_image.src.replace(/(\.[^.]*)$/, '_2400x$1'),
        });
      } else {
        const main = document.querySelector('[data-product-main-image]');
        if (main) {
          main.src = src;
          main.alt = variant.featured_image.alt || product.title;
        }
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  });

  /* ---------- Product gallery: switch + fade + zoom lightbox ---------- */
  window.DrgsklGallery = (function () {
    function getMain(gallery) {
      return gallery && gallery.querySelector('[data-product-main-image]');
    }

    function setMain(gallery, { src, srcset, alt, zoomSrc }) {
      const main = getMain(gallery);
      if (!main || !src) return Promise.resolve();

      return new Promise((resolve) => {
        main.classList.add('is-fading');
        window.setTimeout(() => {
          main.src = src;
          if (srcset) main.setAttribute('srcset', srcset);
          else main.removeAttribute('srcset');
          if (alt != null) main.alt = alt;
          if (zoomSrc) main.dataset.zoomSrc = zoomSrc;
          else if (src) main.dataset.zoomSrc = src.replace(/_1400x/, '_2400x');

          const done = () => {
            main.classList.remove('is-fading');
            main.removeEventListener('load', done);
            resolve();
          };
          if (main.complete) {
            /* next frame so fade-in plays */
            requestAnimationFrame(() => {
              main.classList.remove('is-fading');
              resolve();
            });
          } else {
            main.addEventListener('load', done);
            /* safety */
            window.setTimeout(done, 600);
          }
        }, 180);
      });
    }

    function activateThumb(gallery, thumb) {
      if (!gallery || !thumb) return;
      $$('[data-gallery-thumb]', gallery).forEach((t) => {
        const on = t === thumb;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setMain(gallery, {
        src: thumb.dataset.src,
        srcset: thumb.dataset.srcset,
        alt: thumb.dataset.alt || '',
        zoomSrc: thumb.dataset.zoomSrc || thumb.dataset.src,
      });
    }

    function thumbs(gallery) {
      return $$('[data-gallery-thumb]', gallery);
    }

    function activeIndex(gallery) {
      const list = thumbs(gallery);
      const i = list.findIndex((t) => t.classList.contains('is-active'));
      return i < 0 ? 0 : i;
    }

    /* Lightbox */
    const zoomRoot = document.getElementById('ProductZoom');
    const zoomImg = zoomRoot && zoomRoot.querySelector('[data-zoom-img]');
    let zoomGallery = null;

    function openZoom(gallery) {
      if (!zoomRoot || !zoomImg || !gallery) return;
      zoomGallery = gallery;
      const list = thumbs(gallery);
      const main = getMain(gallery);
      let src =
        (list[activeIndex(gallery)] && list[activeIndex(gallery)].dataset.zoomSrc) ||
        (main && (main.dataset.zoomSrc || main.currentSrc || main.src)) ||
        '';
      if (!src) return;

      zoomImg.classList.remove('is-fading');
      zoomImg.src = src;
      zoomImg.alt = (main && main.alt) || '';
      zoomRoot.hidden = false;
      zoomRoot.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }

    function closeZoom() {
      if (!zoomRoot) return;
      zoomRoot.hidden = true;
      zoomRoot.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      zoomGallery = null;
    }

    function stepZoom(delta) {
      if (!zoomGallery || !zoomImg) return;
      const list = thumbs(zoomGallery);
      if (!list.length) return;
      const next = (activeIndex(zoomGallery) + delta + list.length) % list.length;
      const thumb = list[next];
      activateThumb(zoomGallery, thumb);
      zoomImg.classList.add('is-fading');
      window.setTimeout(() => {
        zoomImg.src = thumb.dataset.zoomSrc || thumb.dataset.src;
        zoomImg.alt = thumb.dataset.alt || '';
        zoomImg.classList.remove('is-fading');
      }, 160);
    }

    document.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb) {
        e.preventDefault();
        e.stopPropagation();
        const gallery = thumb.closest('[data-product-gallery]');
        activateThumb(gallery, thumb);
        return;
      }

      if (e.target.closest('[data-gallery-zoom]')) {
        e.preventDefault();
        const gallery = e.target.closest('[data-product-gallery]');
        openZoom(gallery);
        return;
      }

      if (e.target.closest('[data-zoom-close]')) {
        e.preventDefault();
        closeZoom();
        return;
      }
      if (e.target.closest('[data-zoom-prev]')) {
        e.preventDefault();
        stepZoom(-1);
        return;
      }
      if (e.target.closest('[data-zoom-next]')) {
        e.preventDefault();
        stepZoom(1);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (!zoomRoot || zoomRoot.hidden) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft') stepZoom(-1);
      if (e.key === 'ArrowRight') stepZoom(1);
    });

    return { setMain, activateThumb, openZoom, closeZoom };
  })();

  /* Estimated delivery: today + N days — always English (never browser locale) */
  $$('[data-delivery-eta]').forEach((el) => {
    const days = parseInt(el.dataset.etaDays || '6', 10);
    const dateEl = el.querySelector('[data-eta-date]');
    if (!dateEl) return;
    const d = new Date();
    d.setDate(d.getDate() + days);
    /* Manual English tokens — toLocaleDateString follows browser language (zh-CN → 周三) */
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const daysShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    dateEl.textContent = daysShort[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
  });

  /* Smooth accordion (product + FAQ + any [data-acc]): grid-rows + is-open */
  document.addEventListener('click', (e) => {
    const summary = e.target.closest('[data-acc-summary]');
    if (!summary) return;
    const details = summary.closest('[data-acc]');
    if (!details) return;
    e.preventDefault();

    const willOpen = !details.hasAttribute('open');
    /* Product group: only one open at a time */
    const exclusive = details.closest('[data-product-acc]');
    if (exclusive && willOpen) {
      $$('[data-acc]', exclusive).forEach((other) => {
        if (other !== details && other.hasAttribute('open')) {
          other.classList.remove('is-open');
          window.setTimeout(() => {
            if (!other.classList.contains('is-open')) other.removeAttribute('open');
          }, 420);
        }
      });
    }

    if (willOpen) {
      details.setAttribute('open', '');
      requestAnimationFrame(() => details.classList.add('is-open'));
    } else {
      details.classList.remove('is-open');
      window.setTimeout(() => {
        if (!details.classList.contains('is-open')) details.removeAttribute('open');
      }, 420);
    }
  });

  /* Sync open class for default-open accordion */
  $$('[data-acc][open]').forEach((el) => el.classList.add('is-open'));

  /* Header: fixed top layer + hide on scroll-down / show on any scroll-up */
  const header = $('.site-header');
  const announcement = $('.announcement-bar');
  let lastScrollY = window.scrollY || 0;
  let headerTicking = false;

  function announcementH() {
    return announcement ? announcement.offsetHeight : 0;
  }

  function setAnnouncementHeight() {
    document.documentElement.style.setProperty('--announcement-h', announcementH() + 'px');
  }

  /**
   * Header top offset tracks the announcement as it scrolls away:
   * top = max(0, announcementHeight - scrollY) → never double-covers, no gap.
   */
  function setHeaderTop(y) {
    if (!header || !header.classList.contains('site-header--sticky')) return;
    const ann = announcementH();
    const top = Math.max(0, ann - y);
    document.documentElement.style.setProperty('--header-top', top + 'px');
  }

  function setHeaderOffset() {
    if (!header) return;
    const isHome = document.body.classList.contains('template-index');
    const transparent = header.classList.contains('site-header--transparent');
    const scrolled = header.classList.contains('is-scrolled');
    /*
      Homepage + transparent + not scrolled: hero is full-bleed under nav → spacer 0
      (announcement still in document flow above hero).
      All other cases: reserve header height so content is not covered.
    */
    let offset = 0;
    if (header.classList.contains('site-header--sticky')) {
      if (!(isHome && transparent && !scrolled)) {
        offset = header.offsetHeight;
      }
    }
    document.documentElement.style.setProperty('--header-offset', offset + 'px');
    const spacer = $('#HeaderOffset');
    if (spacer) spacer.style.height = offset + 'px';
  }

  function updateHeader() {
    if (!header) return;
    const y = Math.max(0, window.scrollY || 0);
    const delta = y - lastScrollY;

    header.classList.toggle('is-scrolled', y > Math.max(24, announcementH() * 0.5));
    setHeaderTop(y);

    if (header.classList.contains('site-header--sticky')) {
      /* Near top of page: always show */
      if (y < 64) {
        header.classList.remove('is-hidden');
      } else if (delta > 3) {
        header.classList.add('is-hidden');
      } else if (delta < 0) {
        /* any upward scroll → show immediately */
        header.classList.remove('is-hidden');
      }
    }

    setHeaderOffset();
    lastScrollY = y;
    headerTicking = false;
  }

  function onScroll() {
    if (headerTicking) return;
    headerTicking = true;
    requestAnimationFrame(updateHeader);
  }

  setAnnouncementHeight();
  setHeaderTop(window.scrollY || 0);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => {
    setAnnouncementHeight();
    setHeaderTop(window.scrollY || 0);
    setHeaderOffset();
  });
  updateHeader();

  /* Keep header visible while mobile nav / cart open */
  const headerLock = new MutationObserver(() => {
    if (!header) return;
    if (document.body.classList.contains('overflow-hidden')) {
      header.classList.remove('is-hidden');
    }
  });
  headerLock.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* Reveal on scroll — hero elements fire immediately for above-fold polish */
  const reveals = $$('.reveal');
  const prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showReveal(el) {
    el.classList.add('is-visible');
  }

  /* Hero: cascade in on load (no IO wait) */
  $$('.hero-v3 .reveal').forEach((el, i) => {
    if (prefersReduced) {
      showReveal(el);
      return;
    }
    window.setTimeout(() => showReveal(el), 80 + i * 90);
  });

  const restReveals = reveals.filter((el) => !el.closest('.hero-v3'));
  if (restReveals.length && 'IntersectionObserver' in window && !prefersReduced) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            showReveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );
    restReveals.forEach((el) => io.observe(el));
  } else {
    restReveals.forEach(showReveal);
  }

  /* Sticky ATC */
  const sticky = $('[data-sticky-atc]');
  const productForm = $('form[data-product-form]');
  if (sticky && productForm && 'IntersectionObserver' in window) {
    const io2 = new IntersectionObserver(
      ([entry]) => {
        sticky.classList.toggle('is-active', !entry.isIntersecting);
      },
      { threshold: 0 }
    );
    io2.observe(productForm);
  }

  /* Search open */
  document.addEventListener('click', (e) => {
    const openSearch = e.target.closest('[data-search-open]');
    const closeSearch = e.target.closest('[data-search-close]');
    const panel = $('#SearchPanel');
    if (openSearch && panel) {
      e.preventDefault();
      panel.classList.add('is-open');
      const input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    }
    if (closeSearch && panel) {
      panel.classList.remove('is-open');
    }
  });

  /* Init cart count */
  refreshCartUI();

  /* Money format from Shopify */
  if (window.themeSettings && window.themeSettings.moneyFormat) {
    window.themeMoneyFormat = window.themeSettings.moneyFormat;
  }

  /* Lookbook: prev/next buttons (desktop); touch swipe still native on scroller */
  $$('[data-lookbook]').forEach((root) => {
    const scroller = $('[data-lookbook-scroll]', root);
    const prev = $('[data-lookbook-prev]', root);
    const next = $('[data-lookbook-next]', root);
    if (!scroller || !prev || !next) return;

    function cardStep() {
      const card = scroller.querySelector('.lookbook-card');
      if (!card) return scroller.clientWidth * 0.8;
      const style = window.getComputedStyle(scroller);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      const max = scroller.scrollWidth - scroller.clientWidth - 2;
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max;
    }

    prev.addEventListener('click', () => {
      scroller.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      scroller.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  });
})();
